import { Card, Stack, styled } from '@mui/material';
import { VssPlan, VssPublicAccount } from '@portal-middleware/hooks';
import { ProgressChart } from '@vestwell-frontend/ui';

import { FC, useEffect } from 'react';
import { useToggle } from 'react-use';

import { useGiftStateContext } from '../contexts/GiftStateContext';
import { canGiftAccountRecieveGifts } from '../helpers/giftAccountHelper';
import { GiftInfo } from './GiftInfo';
import { ShareGiftPage } from './ShareGiftPage';

export type LoggedInGiftProgressContainerProps = {
  plan?: VssPlan;
  account?: VssPublicAccount;
};

const StyledShareGiftPage = styled(ShareGiftPage)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));

export const LoggedInGiftProgressContainer: FC<
  LoggedInGiftProgressContainerProps
> = () => {
  const [canRecieveGifts, setCanRecieveGifts] = useToggle(true);
  const { plan, giftAndAccount } = useGiftStateContext();

  useEffect(() => {
    setCanRecieveGifts(canGiftAccountRecieveGifts(giftAndAccount?.data?.data));
  }, [giftAndAccount]);

  if (!canRecieveGifts) {
    return <></>;
  }

  return (
    <Card>
      <Stack flexDirection={{ sm: 'row', xs: 'column' }} gap={8}>
        <Stack>
          {!giftAndAccount?.data?.data?.giftAccount?.hideGoal && (
            <>
              <ProgressChart
                data-testid='giftGoalProgress'
                decimals={1}
                description='Goal Progress'
                format='number'
                total={100}
                value={giftAndAccount?.data?.data?.giftAccount?.goalPercentage}
              />
            </>
          )}
          <GiftInfo
            accountPublic={giftAndAccount.data?.data?.accountPublic}
            mb={0}
            mt={0}
            plan={plan.data?.data}
          />
        </Stack>
        <StyledShareGiftPage />
      </Stack>
    </Card>
  );
};
